<a class="skip-link" href="#main-content" i18n="@@skip.to.main"> Zum Hauptinhalt springen </a>

<div class="content-outlet">
  <router-outlet></router-outlet>
</div>
